var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"relative whitespace-pre-line border-l-2 border-blue-500 pl-[18px] text-gray-400"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }